const Error = props =>{
  test = {}
  test.error.error = 'error'
  return (<div>hey</div>)
}

export default Error
